<template>
    <component :is="resolvedLayout"></component>
</template>

<script>
import InternalLayout from "@/views/layout/internal";
import GuestLayout from "@/views/layout/guest";
import {resolveStoreAccess} from "@/utils/access-context";

export default {
    name: "workspace",
    components: {InternalLayout, GuestLayout},
    computed: {
        accessContext() {
            return resolveStoreAccess(this.$store);
        },
        resolvedLayout() {
            return this.accessContext.template_family === 'guest'
                ? 'GuestLayout'
                : 'InternalLayout';
        },
    }
}
</script>
